import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/cal.com/apps/web/modules/apps/[slug]/slug-view.tsx");
